import {mapGenerator} from '../config/axios'

export const deploySensors = (sensor, map, callback) => {
    return mapGenerator.post('/sensors/' + map + '/deploy', sensor)
        .then((response) => {
            if (response.status === 200) {
                return response.data;
            } else {
                return [];
            }
        })
        .then((points) => {
            callback(points)
        })
        .catch((err) => {
            console.log(err)
        })
}

export const getSensors = (map, callback) => {
    return mapGenerator.get('/sensors/data/' + map)
        .then((response) => {
            if (response.status === 200) {
                return response.data;
            } else {
                return [];
            }
        })
        .then((points) => callback(points))
        .catch((err) => console.log(err))
}

export const getAdminSensors = (map, callback) => {
    return mapGenerator.get("/sensors/" + map)
        .then((response) => {
            if (response.status === 200) {
                return response.data
            } else {
                return []
            }
        })
        .then((points) => callback(points))
        .catch((err) => console.log(err))
}

export const getSensorsFromtimestamp = (map, timestamp, callback) => {
    return mapGenerator.get("/sensors/data/"+ map +"?timestamp=" + timestamp)
        .then((response) => {
            if (response.status === 200) {
                return response.data
            } else {
                return []
            }
        })
        .then((sensors) => callback(sensors))
        .catch((err) => console.log(err))

}

export const postSensor = (map, sensor, callback) => {
    return mapGenerator.post('/sensors/' + map, sensor)
        .then((response) => callback(response.data))
        .catch(() => console.log("ERROR Posting a Sensor!"))
}

export const deleteSensor = (map, id, callback) => {
    return mapGenerator.delete(`/sensors/${map}/${id}`)
        .then(() => callback())
        .catch((err) => console.log(err))
}

export const deleteAllSensors = (map, callback) => {
    return mapGenerator.delete('/sensors/' + map)
        .then((response) => {
            callback(response.status)
        })
        .catch((error) => {
            console.error(error)
        })
}

export const updateSensor = (map, sensor, callback) => {
    return mapGenerator.put(`/sensors/${map}/${sensor.id}`, sensor)
        .then(response => callback(response.data, false))
        .catch(err => callback(err, true))
}



// WEBPACK FOOTER //
// ./src/requests/sensors.js